<template>
  <MainCard
    title="Dados"
    subtitle="Reservatório digital onde dados de diferentes fontes são coletados, armazenados e processados."
    sb="Saiba mais"
    link="https://crmrubeus.zendesk.com/hc/pt-br/articles/32260485588749-Acessando-as-configurações-de-fontes-de-dados-no-AI-Studio"
    :beta="true"
  >
    <v-sheet class="pa-4">
      <NavigationCard
        :items="processedCardData"
        md="6"
        lg="5"
        xlg="5"
        titlecolor="#505353"
        titlefontfamily="Roboto"
        titlefontsize="16px"
        titlefontstyle="normal"
        titlefontweight="500"
        titlelineheight="23.4px"
        typecolor=""
        typefontfamily=""
        typefontsize=""
        typefontstyle=""
        typefontweight=""
        typelineheight=""
        desccolor="#505353"
        descfontfamily="Roboto"
        descfontsize="14px"
        descfontstyle="normal"
        descfontweight="400"
        desclineheight="20px"
        cardWidth="426px"
        cardHeight="168px"
        actionType="redirect"
      ></NavigationCard>
    </v-sheet>
  </MainCard>
</template>

<script>
import MainCard from "@/ai_studio/components/layout/MainCard.vue";
import NavigationCard from "@/ai_studio/components/common/NavigationCard.vue";

export default {
  name: "DataView",
  data() {
    return {
      CardData: this.$route.meta.data_names,
    };
  },
  components: {
    MainCard,
    NavigationCard,
  },
  computed: {
    processedCardData() {
      if (!this.CardData) {
        return [];
      }
      
      return this.CardData.map(item => {
        return {
          ...item,
          route: "/definitions/" + item.id
        };
      });
    }
  },
  methods: {},
};
</script>